<div class="center center-container">
  <div class="m-b-20">
    <img src="../../../../../assets/greydom.png" alt="Greydom logo"/>
  </div>
  <p>{{DisplayStrings.permissionsErrorMessages?.cannotAccessPortal}}</p>
</div>
